import { Typography } from "@mui/material";

export default function News() {
    return (
        <Typography
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "93vh",
                color: "text.disabled",
            }}
            variant="h6"
        >
            - Nenhuma Notícia Recente -
        </Typography>
    );
}
